import React from 'react'
import { csx } from '@vtex/admin-ui'
import { Product } from '@/checkout-instore-legacy/components/Product/Product'

export type ProductCarouselItemProps = {
  children: React.ReactNode
} & React.ComponentProps<'div'>

export const ProductCarouselItem = ({
  children,
  ...props
}: ProductCarouselItemProps) => (
  <Product
    className={csx({
      border: '0.5rem solid transparent',
      '@desktop': {
        borderWidth: '1.25rem',
      },
    })}
    {...props}
  >
    {children}
  </Product>
)
